import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # HospitalInfo
 *
 * 병원정보
 */
export const HospitalInfo = types
  .model('HospitalInfo')
  // --------------------------------------------------------------------------
  .props({
    hsptlSid: types.number,
    hsptlNm: types.string,
    hsptlNmEng: types.string,
    useYn: types.string,
    regDt: types.string,
    updDt: types.string,
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model hospitalInfo --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IHospitalInfo;
      (Object.keys(newProps) as THospitalInfoKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type THospitalInfo = Instance<typeof HospitalInfo>;
type THospitalInfoSnapshot = SnapshotOut<typeof HospitalInfo>;

export interface IHospitalInfo extends THospitalInfo {}
export type THospitalInfoKeys = keyof THospitalInfoSnapshot & string;
export interface IHospitalInfoSnapshot extends THospitalInfoSnapshot {}
export const createHospitalInfo = () => types.optional(HospitalInfo, {} as THospitalInfo);
